<template>
  <ValidationObserver ref="form">
    <form @submit.prevent="validate">
      <div>
        <div class="md-layout text-center">
          <div class="md-layout-item md-size-80 mt-4 md-small-size-100 no-margin">

            <div class="md-layout text-center" v-if="!isReseller">
              <div class="md-layout-item md-size-80 md-small-size-100">
                <div class="md-layout">
                  <div class="md-layout-item md-size-50 md-small-size-50" @click="setDocType('CPF')">
                    <icon-checkbox
                      :class="{ 'active': docType == 'CPF' }"
                      icon="fas fa-user-alt"
                      title="Pessoa Física"                      
                    >
                    </icon-checkbox>
                  </div>
                  <div class="md-layout-item md-size-50 md-small-size-50" @click="setDocType('CNPJ')">
                    <icon-checkbox
                      :class="{ 'active': docType == 'CNPJ' }"
                      icon="fas fa-building"
                      title="Pessoa Jurídica"                      
                    >
                    </icon-checkbox>
                  </div>
                </div>
              </div>
            </div>

            <CollapseContent              
              :active="docType != '' ? true : false"
              color-collapse="success"
              style="margin-top: 20px;"
              >
              <template slot="md-collapse-content">
            
                <ValidationProvider
                  name="docNumber"
                  rules="required"
                  v-slot="{ passed, failed }"
                >
                  <md-field
                    :class="[
                      { 'md-error': failed || !docValid },
                      { 'md-valid': passed && docValid },
                      { 'md-form-group': true }
                    ]"
                  >
                    <md-icon>subtitles</md-icon>
                    <label>Informe seu {{docType}}</label>
                    <md-input v-mask="docMask" v-model="docNumber" type="text"> </md-input>

                    <slide-y-down-transition>
                      <md-icon class="error" v-show="failed || !docValid">close</md-icon>
                    </slide-y-down-transition>
                    <slide-y-down-transition>
                      <md-icon class="success" v-show="passed && docValid">done</md-icon>
                    </slide-y-down-transition>
                  </md-field>
                </ValidationProvider>
                
                <CollapseContent              
                  :active="docType == 'CNPJ' ? true : false"
                  color-collapse="success">
                  <template slot="md-collapse-content">
                    <ValidationProvider                      
                      name="company"                      
                      :rules="{
                        required: docType == 'CNPJ', 
                        regex: /(\D{2,})/ 
                      }"

                      v-slot="{ passed, failed }"
                    >
                      <md-field
                        :class="[
                          { 'md-error': failed },
                          { 'md-valid': passed },
                          { 'md-form-group': true }
                        ]"
                      >
                        <md-icon>business</md-icon>
                        <label>Nome da empresa</label>
                        <md-input v-model="company" type="text"> </md-input>

                        <slide-y-down-transition>
                          <md-icon class="error" v-show="failed">close</md-icon>
                        </slide-y-down-transition>
                        <slide-y-down-transition>
                          <md-icon class="success" v-show="passed">done</md-icon>
                        </slide-y-down-transition>
                      </md-field>
                    </ValidationProvider>
                  </template>              
                </CollapseContent>

                <CollapseContent
                  :active="!docValid">
                  <template slot="md-collapse-content">
                    <div class="md-layout-item md-layout-item md-size-100 mx-auto text-center">
                      <p class="additional-info" v-if="!isReseller">
                        De acordo com o Decreto Federal nº 7962/13, todas as lojas virtuais precisam apresentar CPF ou CNPJ no rodapé. Isso traz maior segurança e credibilidade aos seus clientes.
                      </p>
                      <p class="additional-info" v-if="isReseller">
                        Para se cadastrar como um revendedor white label você precisa completar seu cadastro como pessoa jurídica.
                      </p>
                      <p class="additional-info">
                        Caso precise mudar essa informação depois, você poderá fazer pelo seu painel de controle.
                      </p>
                    </div>
                  </template>              
                </CollapseContent>
  
                <CollapseContent><!--:active="docValid"-->
                  <template slot="md-collapse-content">

                    <div class="md-layout text-center">
                      <div class="md-layout-item md-size-70 md-small-size-100">
                        <span class="register-separator">Informações adicionais <small class="mobile-hidden"> (opcional)</small></span>
                      </div>
                    </div>

                    <md-field style="margin-top: 0;">
                      <md-icon>storefront</md-icon>
                      <label for="segments" v-if="!isReseller">Quais seus principais segmentos?</label>
                      <label for="segments" v-if="isReseller">Quais principais segmentos você atende?</label>
                      <md-select
                        v-model="mainSegments"
                        name="segments"
                        id="segments"
                        multiple
                      >
                        <md-option value="Alimentos e Bebidas">Alimentos e Bebidas</md-option>
                        <md-option value="Autopeças e acessórios">Autopeças e acessórios</md-option>
                        <md-option value="Brinquedos">Brinquedos</md-option>
                        <md-option value="Casa e Decoração">Casa e Decoração</md-option>
                        <md-option value="Eletrodomésticos">Eletrodomésticos</md-option>
                        <md-option value="Eletrônicos">Eletrônicos</md-option>
                        <md-option value="Esporte e Lazer">Esporte e Lazer</md-option>                    
                        <md-option value="Games">Games</md-option>
                        <md-option value="Informática">Informática</md-option>
                        <md-option value="Jóias e Semijóias">Jóias e Semijóias</md-option>
                        <md-option value="Livros, assinaturas e apostilas">Livros, assinaturas e apostilas</md-option>
                        <md-option value="Moda e Acessórios">Moda e Acessórios</md-option>
                        <md-option value="Móveis">Móveis</md-option>
                        <md-option value="Perfurmaria e Cosméticos">Perfurmaria e Cosméticos</md-option>
                        <md-option value="Petshop">Petshop</md-option>
                        <md-option value="Saúde e Beleza">Saúde e Beleza</md-option>
                        <md-option value="Telefonia e Celulares">Telefonia e Celulares</md-option>                    
                      </md-select>
                    </md-field>

                    <md-field>
                      <md-icon>add_business</md-icon>
                      <label for="marketplaces" v-if="!isReseller">Utiliza outros canais de venda?</label>
                      <label for="marketplaces" v-if="isReseller">Quais outros canais seus clientes utilizam?</label>
                      <md-select
                        v-model="usedMarketplaces"
                        name="marketplaces"
                        id="marketplaces"
                        multiple
                      >
                        <md-option value="Mercado Livre">Mercado Livre</md-option>
                        <md-option value="Magazine Luiza">Magazine Luiza</md-option>
                        <md-option value="Amazon">Amazon</md-option>

                        <md-option value="Americanas">Americanas</md-option>
                        <md-option value="Submarino">Submarino</md-option>
                        <md-option value="Shoptime">Shoptime</md-option>

                        <md-option value="Carrefour">Carrefour</md-option>

                        <md-option value="Casas Bahia">Casas Bahia</md-option>
                        <md-option value="Extra">Extra</md-option>
                        <md-option value="Ponto Frio">Ponto Frio</md-option>

                        <md-option value="Netshoes">Netshoes</md-option>
                        <md-option value="Dafiti">Dafiti</md-option>                    
                        <md-option value="Tricae">Tricae</md-option>
                        <md-option value="Zatini">Zatini</md-option>

                        <md-option value="Madeira Madeira">Madeira Madeira</md-option>
                        <md-option value="Mobly">Mobly</md-option>

                        <md-option value="Wish">Wish</md-option>
                        <md-option value="Shopee">Shopee</md-option>

                        <md-option value="Google Shopping">Google Shopping</md-option>                    
                        <md-option value="Facebook Marketplace">Facebook Marketplace</md-option>
                        <md-option value="Instagram">Instagram</md-option>                    

                        <md-option value="OLX">OLX</md-option>
                        <md-option value="Zoom">Zoom</md-option>
                      </md-select>
                    </md-field>

                    <md-field>
                      <md-icon>code</md-icon>
                      <label for="platforms">Já utilizou outras plataformas?</label>
                      <md-select
                        v-model="usedPlatforms"
                        name="platforms"
                        id="platforms"
                        multiple
                      >
                        <md-option value="Loja Integrada">Loja Integrada</md-option>
                        <md-option value="Nuvemshop">Nuvemshop</md-option>
                        <md-option value="Shopify">Shopify</md-option>
                        <md-option value="Simplo7">Simplo7</md-option>
                        <md-option value="WBuy">WBuy</md-option>
                        <md-option value="WooCommerce">WooCommerce</md-option>

                        <md-option value="Tray">Tray</md-option>                    
                        <md-option value="Tray Corp">Tray Corp</md-option>
                        <md-option value="Magento">Magento</md-option>
                        <md-option value="Xtech">Xtech</md-option>
                        <md-option value="Vtex">Vtex</md-option>
                        <md-option value="Linx">Linx</md-option>
                        
                        <md-option value="Open Cart">Open Cart</md-option>
                        <md-option value="Prestashop">Prestashop</md-option>
                        <md-option value="Wix">Wix</md-option>                  
                        <md-option value="Bagy">Bagy</md-option>
                        <md-option value="Irroba">Irroba</md-option>
                        <md-option value="Dooca">Dooca</md-option>
                        <md-option value="Webstore">Webstore</md-option>
                        <md-option value="Betalabs">Betalabs</md-option>
                        <md-option value="E-com Club">E-com Club</md-option>
                      </md-select>
                    </md-field>
                    
                  </template>
                </CollapseContent>


              </template>
            </CollapseContent>

          </div>
        </div>
      </div>
    </form>
  </ValidationObserver>
</template>
<script>
import { IconCheckbox } from "@/components";
import { SlideYDownTransition } from "vue2-transitions";
import { extend } from "vee-validate";
import { CollapseContent } from '@/components'
import { regex, required, is, min } from "vee-validate/dist/rules";
extend("required", required);
extend("regex", regex);
extend("is", is);
extend("min", min);

export default {
  components: {
    IconCheckbox,
    SlideYDownTransition,
    CollapseContent
  },
  data() {
    return {
      session: this.$store.state.session,
      business: this.$store.state.business,

      isReseller: this.$store.state.session.gid == "51",

      docType: "",
      docNumber: this.$store.state.business.docNumber,
      company: "",
      mainSegments: "",
      usedMarketplaces: "",
      usedPlatforms: "",
      
      docMask: '###.###.###-##',
      docValid: null,
    };
  },

  mounted: function () {
    this.$nextTick(function () {
      this.$debug('loading SecondStep:');
      this.$debug(this.business);
      if (this.isReseller) this.docType = "CNPJ";
      if (this.business.docType) this.docType = this.business.docType;
      if (this.business.company) this.company = this.business.company;
      if (this.business.mainSegments) this.mainSegments = this.business.mainSegments;
      if (this.business.usedMarketplaces) this.usedMarketplaces = this.business.usedMarketplaces;
      if (this.business.usedPlatforms) this.usedPlatforms = this.business.usedPlatforms;      
    })
  },

  watch:{
    docType: function(val){
      this.docNumber = "";

      if (val == 'CNPJ') 
        this.docMask = '##.###.###/####-##';
      else {
        this.docMask = '###.###.###-##';
        this.company = "";
      }      
    },

    docNumber: function(val){
      this.docValid = false;

      if (this.docType == 'CNPJ')
        this.docValid = this.$functions.validateCNPJ(val);
      else if (this.docType == 'CPF')
        this.docValid = this.$functions.validateCPF(val);

      if (this.docValid){
        const params = {'id'            : this.$store.state.session.id,
                        'email'         : this.$store.state.client.email,                        
                        'persontype'    : this.docType };
        this.$functions.addTrack(params);
      }
    }

  },

  methods: {
    validate() {
      return this.$refs.form.validate().then(res => {
        if (!this.docValid) res = false;
        this.$emit("on-validated", res);
        return res;
      });
    },

    setDocType(docType){ this.docType = docType; },
  }
};
</script>
<style lang="scss">

.no-margin{
  margin: 0px !important;
}

.md-card-wizard .choice i {
  font-size: 50px !important;
  color: #1565c0;
}

.md-card-wizard .choice.active i {
  color: white;
}

.md-card-wizard .choice.active .icon {
  background-color: #1565c0;
}

.md-card-wizard .choice h6{
  margin-block-start: 0px;
  margin-block-end: 0px;
  color: #555;
}

.md-card-wizard .choice.active h6{
  color: #1565c0;
}

.md-input.md-select-value{
  font-size: 18px !important;
}

.additional-info{
  font-size: 14px !important;
  line-height: 20px;
  color: #555;
}

.register-separator {
  display: flex;
  align-items: center;
  text-align: center;
  opacity: 0.4;
  font-size: 16px;
  margin-top: 1rem;
  margin-bottom: 0px;
}
.register-separator::before, .register-separator::after {
  content: '';
  flex: 1;
  border-bottom: 1px solid #999;
}
.register-separator::before {
  margin-right: 1em;  
}
.register-separator::after {
  margin-left: 1em;  
}

.register-separator small{
  margin-left: 0.5rem;
}

@media only screen and (max-width: 600px) {
  .md-card-wizard .choice i {
    font-size: 20px !important;
    line-height: 40px !important;
  }

  .md-card-wizard .choice .icon {
    width: 50px !important;
    height: 50px !important;
    margin-bottom: 10px;
  }

  .md-card-wizard .choice h6{
    font-size: 0.8rem;
    font-weight: normal;
    text-transform: initial;
  }

  .md-card-actions{
    padding-top : 0px !important;
  }

}

</style>
